import React from 'react';
import { View, Text, ActivityIndicator } from 'react-native';
import { Button } from 'root/globals/Elements';
import CustomTable from 'root/libs/exaforte/react/CustomTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'root/libs/exaforte/react/lodash';

import { 
    faUndo,
} from '@fortawesome/pro-regular-svg-icons';


import defaults from 'root/globals/Defaults.less';
import table from './Table.less';

const styles = {...defaults, ...table};

export default class Table extends React.Component {
    constructor(props) {
        super(props);
        
        this.formatView = this.formatView.bind(this);
    }

    formatView(value, column, row, is_subtable, headers){
        let element = (this.props.getDataField ? this.props.getDataField(value, column, row, is_subtable, headers) : value);
        
        return <View className={['d-flex flex-row align-items-center' + (column.id == 'model_actions' ? '' : ' w-100')]}>
            {this.props.has_header && <Text className={['pb-2 pr-1 pl-3 p-' + this.props.breakpoint + '-0 d-' + this.props.breakpoint + '-none' + (column.first ? ' pt-4' : '') + (column.last ? ' pb-4' : ''), styles['text-ellipsis'], styles['flex-1']]}>{column.Header}</Text>}
            <View className={['py-2 px-3 p-' + this.props.breakpoint + '-0' + (column.first ? ' pt-4' : '') + (column.last ? ' pb-4' : ''), ...(this.props.has_header ? [styles['bl-1'], styles['bl-' + this.props.breakpoint + '-0']] : []), styles['border-color-light-grey'], styles['flex-2'], ...(this.props.ellipsis ? [styles['text-ellipsis']] : [])]}>{element}</View>
        </View>;
    }
    
    mergeClassnames(objValue, srcValue) {
        if(_.isArray(objValue))
            return objValue.concat(srcValue);
        else if(typeof objValue == 'string')
            return objValue + ' ' + srcValue;
    }

    render() {
        let filters_applied         = (this.props.controller && this.props.controller.config.filter ? _.size(this.props.controller.config.filter.get_filter()) : 0);
        let loadingElement          = <View className={['d-flex justify-content-center mt-4']}>
                                        <ActivityIndicator size={'lg'} />
                                    </View>;
        let emptyResponseElement    = <View>
                                        <View className={['row d-flex justify-content-center mt-4']}>
                                            {this.props.elementResponseElement || <Text className={[styles['f-2-2-5']]}>{this.props.controller && this.props.controller.config.filter && filters_applied > 0 ? 'Er zijn geen items gevonden' : 'Er zijn nog geen items toegevoegd'}</Text>}
                                        </View>
                                        {(this.props.controller && this.props.controller.config.filter && filters_applied > 0) && <View className={['d-flex justify-content-center align-items-center mt-4']}>
                                            <Text className={['mr-3', styles['text-light'], styles['color-grey'], styles['f-1-5']]}>{filters_applied} filter{_.plural({amount: filters_applied, plural: 's'})} toegepast</Text> 
                                            <Button secondary={true} onPress={this.props.controller.config.filter.reset} className={['d-flex flex-row']}>
                                                <Text className={['mr-1']}>Reset</Text>
                                                <FontAwesomeIcon icon={faUndo} />
                                            </Button>
                                        </View>}
                                    </View>;

        let classNames      = this.props.override_classnames ? _.merge({ table: styles['table'], body: styles['body'], header: styles['header'], th: [styles['th'], styles['f-1-7-5'], 'd-none d-' + this.props.breakpoint + '-flex align-items-center py-3 px-3', styles['custom-table-head-td']].join(' '), tr: [styles['tr'], 'd-block d-' + this.props.breakpoint + '-flex'].join(' '), td: [styles['td'], styles['f-1-5'], 'align-items-center', styles['custom-table-td'], styles['color-dark-grey'], 'd-block d-' + this.props.breakpoint + '-flex px-3 py-3 font-weight-light'].join(' '), selected: [styles['selected']].join(' ') }, this.props.classNames) : _.mergeWith({ table: styles['table'], body: styles['body'], header: styles['header'], th: [styles['th'], styles['f-1-7-5'], 'd-none d-' + this.props.breakpoint + '-flex align-items-center py-3 px-3', styles['custom-table-head-td']].join(' '), tr: [styles['tr'], 'd-block d-' + this.props.breakpoint + '-flex'].join(' '), td: [styles['td'], styles['f-1-5'], 'align-items-center', styles['custom-table-td'], styles['color-dark-grey'], 'd-block d-' + this.props.breakpoint + '-flex px-3 py-3 font-weight-light'].join(' '), selected: [styles['selected']].join(' ') }, this.props.classNames, this.mergeClassnames);
        classNames.table    += ' ' + styles['table-' + this.props.breakpoint + '-responsive'];

        return <CustomTable fetching={this.props.controller && this.props.controller.component.state.fetching} emptyResponseElement={emptyResponseElement} loadingElement={loadingElement} formatData={this.props.formatData || this.formatView} classNames={classNames} {..._.omit(this.props, ['formatData', 'classNames'])} />;
    }
}

Table.defaultProps = {
    classNames: {},
    breakpoint: 'md',
    ellipsis: true,
    sticky: false,
    has_header: true,
    override_classnames: true,
}